var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Configure mappings")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/pipelines/details/${_setup.tid}/${_setup.id}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-5 text-right",
              class: {
                "order-1": _setup.direction == 1,
                "order-3": _setup.direction == 2,
              },
            },
            [_c("h5", [_vm._v("Connector")])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 order-2 text-center" }, [
            _setup.direction == 1
              ? _c("i", {
                  staticClass: "fa fa-arrow-circle-right fa-2x",
                  attrs: { title: "From connector to dataset" },
                })
              : _vm._e(),
            _vm._v(" "),
            _setup.direction == 2
              ? _c("i", {
                  staticClass: "fa fa-arrow-circle-right fa-2x",
                  attrs: { title: "From dataset to connector" },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-5",
              class: {
                "order-1": _setup.direction == 2,
                "order-3": _setup.direction == 1,
              },
            },
            [_c("h5", [_vm._v("Dataset")])]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2" }, [
          _c(
            "div",
            {
              staticClass: "col-5",
              class: {
                "order-1": _setup.direction == 1,
                "order-3": _setup.direction == 2,
              },
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _setup.nameForConnector,
                      expression: "nameForConnector",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _setup.nameForConnector = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_setup.availablePropertyNames, function (p) {
                  return _c("option", [_vm._v(_vm._s(p))])
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 order-2 text-center" }, [
            _c(
              "button",
              {
                staticClass: "btn bt-sm btn-secondary",
                on: { click: _setup.handleAddPropertyNameMappingCommand },
              },
              [_vm._v("Add")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-5",
              class: {
                "order-1": _setup.direction == 2,
                "order-3": _setup.direction == 1,
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _setup.nameForDataset,
                    expression: "nameForDataset",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _setup.nameForDataset },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.nameForDataset = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm._l(_setup.mappings, function (m) {
          return _c("div", { staticClass: "row mb-1" }, [
            _c(
              "div",
              {
                staticClass: "col-5 text-right",
                class: {
                  "order-1": _setup.direction == 1,
                  "order-3": _setup.direction == 2,
                },
              },
              [_c("strong", [_vm._v(_vm._s(m.NameForConnector))])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 order-2 text-center" }, [
              _c(
                "a",
                {
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      return _setup.handleRemovePropertyNameMappingCommandV1(m)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-remove fg-color-red",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-5",
                class: {
                  "order-1": _setup.direction == 2,
                  "order-3": _setup.direction == 1,
                },
              },
              [_c("strong", [_vm._v(_vm._s(m.NameForDataset))])]
            ),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }